import { useMutation } from "@tanstack/react-query";
import { sendContact, ContactRequest } from "../api/feedback";

export function useSendContact() {
  return useMutation({
    mutationFn: (contact: ContactRequest) => sendContact(contact),
  });
}

